import {
    Component,
    OnInit,
    OnChanges,
    Input,
    ViewChild
} from '@angular/core';

import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { BehaviorSubject } from 'rxjs';

import { RoomRangePipe } from '../room-range.pipe';

interface TableRow {
    _id: string;
}

@Component({
    selector: 'app-market-table-orders',
    templateUrl: './table-orders.component.pug',
    styleUrls: ['./table-orders.component.less'],
    providers: [RoomRangePipe]
})
export class TableOrdersComponent implements OnInit, OnChanges {
    @Input() room: string = '';
    @Input() worldSize: { width: number, height: number };
    @Input() shard: string;
    @Input() data: TableRow[] = [];
    @Input() sort: 'asc' | 'desc' | '';

    @ViewChild(MatSort, {static: false}) matSort: MatSort;

    private _columnsSbj = new BehaviorSubject<string[]>([
        '_id', 'price', 'amount', 'remainingAmount', 'roomName', 'range'
    ]);

    public dataSource: MatTableDataSource<any[]> = new MatTableDataSource([]);
    public columns$ = this._columnsSbj.asObservable();

    constructor(
        private _roomRange: RoomRangePipe
    ) {
    }

    ngOnInit() {
        if (this.worldSize) {
            return;
        }

        this._columnsSbj.next([
            '_id', 'price', 'amount', 'remainingAmount'
        ]);
    }

    ngOnChanges(changes) {
        if ('data' in changes) {
            this.dataSource = new MatTableDataSource(changes.data.currentValue);
            setTimeout(() => {
                this.dataSource.sort = this.matSort;
            });

            this.dataSource.sortingDataAccessor = (data, sortHeaderId) => {
                if (sortHeaderId === 'range') {
                    return this._roomRange.transform(data['roomName'], this.room, this.worldSize);
                }

                return data[sortHeaderId];
            };
        }
    }

}
